<template>
  <div class="splash-screen">
    <div
      class="d-flex flex-column justify-content-center align-items-center vh-100 text-center px-4"
    >
      <div class="brand-detail">
        <div
          class="d-flex justify-content-center align-items-center"
          v-if="
            organizationDetails && Object.keys(organizationDetails).length > 0
          "
        >
          <img
            :src="organizationDetails.org_logo_url"
            :class="isQfx ? `bg-dark`: ``"
            width="465"
            class="login-brand"
            alt
          />
        </div>
        <img
          v-else-if="isPlatinum"
          src="@/assets/img/clients/platinumcinemas.png"
          height="auto"
          width="465"
          class="login-brand"
        />
        <img
          v-else-if="isQfx"
          src="@/assets/img/clients/qfxcinemas_dark.jpg"
          height="auto"
          width="465"
          class="login-brand"
        />
        <img
          v-else
          :src="isQfx ? qfxLogo : nuvioLogo"
          height="auto"
          width="465"
          class="login-brand"
        />
        <div>
          <p>
            <span class="text-muted fs-12">Powered By</span>&nbsp;&nbsp;
            <span class="poweredbylogo">
              <img
                :src="isQfx ? qfxLogo : nuvioLogo"
                height="auto"
                width="30"
                class="login-brand"
              />
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qfxLogo from "@/assets/img/logos/logo-dark.png";
import nuvioLogo from "@/assets/img/logos/Nuvio_Black.png";
export default {
  name: "BookingSuccess",
  props: {
    organizationDetails: {
      type: Object,
    },
  },
  data() {
    return {
      qfxLogo,
      nuvioLogo,
    };
  },
  computed: {
    isPlatinum() {
      let hostname = window.location.hostname;
      return hostname.includes("platinum");
    },
    isQfx() {
      let hostname = window.location.hostname;
      return hostname.includes("qfx");
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.fs-12 {
  font-size: 12px;
}
.splash-screen {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff; /* base background */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.splash-screen::before,
.splash-screen::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  /* background-repeat: no-repeat; */
  opacity: 0.3; /* faint */
  filter: blur(15px);
  z-index: 0;
}

/* .splash-screen::before {
  background-image:  url("~@/assets/img/backgrounds/moviereel.jpg");
  top: -50px;
  left: -50px;
} */

.splash-screen::after {
  background-image: url("~@/assets/img/backgrounds/popCornHome.png");
  /* bottom: -50px; */
  right: 180px;
}

.brand-detail {
  z-index: 5;
}

.bg-dark {
  background: #000000;
  border-radius: 25px;
}
</style>
